require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tapd-in-do-this-before-you-run-another-facebook-ad.json") })
        }
      }, "path---tapd-in-do-this-before-you-run-another-facebook-ad");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tapd-in-do-this-before-you-run-another-facebook-ad!./.cache/json/tapd-in-do-this-before-you-run-another-facebook-ad.json
// module id = 823
// module chunks = 231608221292675